import { Directive, ElementRef, Renderer2, HostListener, EventEmitter, Input, Output } from '@angular/core';
import { NgModel } from '@angular/forms';
import { KeyboardServiceService } from '../keyboard-service/keyboard-service.service';

@Directive({
  selector: '[ngModel][gsKeyboard]',
  providers: [NgModel]
})

export class GsKeyboardDirective {
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter(false);

  @Input() isNumberPad: boolean;

  private isFocused: boolean = true;
  private currentValue: string = '';

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private ngModel: NgModel,
    private keyboard: KeyboardServiceService
  ) {}  

  @HostListener('blur', ['$event'])
  onblur($event) {
  }

  @HostListener('focus', ['$event'])
  onfocus($event) {

    if(this.isNumberPad) {
      this.keyboard.isNumberPad = this.isNumberPad;
    } else {
      this.keyboard.isNumberPad = false;
    }

    this.keyboard.currentModel = this.ngModel.name;
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/keyboard-directive/gskeyboard.directive.ts